<input
  #otpCode
  type="text"
  id="code"
  inputmode="numeric"
  autocomplete="one-time-code"
  maxlength="6"
  class="w-full text-center font-mono tracking-[0.5em]"
  [value]="value()"
  (input)="onInput($event)"
  (blur)="touched.set(true)" />
